(function ($) {
    $(function () {
        var scrollspyMarkup = null;
        $('.content').animate({ opacity: 1 }, 1000);
        $(function () {
            $('[data-toggle="tooltip"]').tooltip();
        });

    });
})(jQuery);
